<div class="mt-5">
    <div class="email-editor-wrapper">
        <div [id]="toolbarId" class="mb-1"></div>
        <div [id]="emailEditorId" class="border border-zen-neutralp90 rounded overflow-hidden"></div>
    </div>

</div>